import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { FreeCourseNotice } from './FreeCourseNotice';
import { KeyHighlights } from './KeyHighlights';
import { CourseDescription } from './CourseDescription';
import { TopicsCovered } from './TopicsCovered';
import { RegistrationCallout } from './RegistrationCallout';
import { QuickLinks } from './QuickLinks';
export function CRASEPage() {
  return <PageLayout data-id="element-1268">
      <HeaderBanner data-id="element-1269" />
      <FreeCourseNotice data-id="element-1270" />
      <KeyHighlights data-id="element-1271" />
      <CourseDescription data-id="element-1272" />
      <TopicsCovered data-id="element-1273" />
      <RegistrationCallout data-id="element-1274" />
      <QuickLinks data-id="element-1275" />
    </PageLayout>;
}